export default "__VITE_ASSET__scSjNY_h__"